<template>
    <div class="special-symbols">
        <form class="form" @submit.prevent="save()">
            <Spinner v-if="loading" />
            <div class="form-group">
                <label v-t="'editor.specialSymbols.form.sourceLabel'" class="form-group__label" />
                <FormInput
                    v-model="values.symbol"
                    :placeholder="$t('editor.specialSymbols.form.sourcePlaceholder')"
                    name="symbol"
                    required
                />
            </div>
            <div class="form-group">
                <label v-t="'editor.specialSymbols.form.replaceLabel'" class="form-group__label" />
                <FormInput
                    v-model="values.replace"
                    :placeholder="$t('editor.specialSymbols.form.replacePlaceholder')"
                    required
                />
            </div>
            <template v-if="!symbol">
                <div class="form-group">
                    <label class="form-group__label">Язык</label>
                    <MultiSelect
                        v-model="values.lang"
                        :options="languages"
                        :form-value-text="(item) => item.label.original || item.label[$i18n.locale]"
                        with-filter
                        emit-prop="id"
                        empty-text="No languages"
                        style="width: 360px"
                        required
                    >
                        <template #default="{ item }">
                            {{ item.label.original || item.label[$i18n.locale] }}
                        </template>
                    </MultiSelect>
                </div>
                <div class="form-group">
                    <label class="form-group__label">Провайдер</label>
                    <CustomSelect
                        v-model="values.provider"
                        :options="providers"
                        :form-value-text="(item) => item.name"
                        emit-prop="id"
                        style="max-width: 360px; margin-top: 10px"
                        required
                    >
                        <template #default="{ item }">
                            {{ item.name }}
                        </template>
                    </CustomSelect>
                </div>
            </template>
            <div class="special-symbols__footer">
                <button v-t="'misc.add'" :disabled="loading" class="button button--medium" />
            </div>
            <ErrorList :error="error" />
        </form>
    </div>
</template>

<script>
import {
    FormInput,
    CustomSelect,
    ErrorList,
    MultiSelect,
} from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'SpecialSymbols',
    components: {
        FormInput,
        CustomSelect,
        ErrorList,
        MultiSelect,
    },
    props: {
        symbol: {
            type: Object,
            default: null,
        },
        languages: {
            type: Array,
            default: () => [],
        },
        providers: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            values: {
                symbol: '',
                replace: '',
                is_active: true,
                provider: undefined,
                lang: [],
            },
            loading: false,
            error: undefined,
            keep: false,
        };
    },
    methods: {
        async save() {
            try {
                this.error = undefined;
                this.loading = true;

                let { symbol, replace, is_active, provider, lang } = this.values;
                let data = {
                    symbol,
                    replace,
                    is_active,
                    provider: provider,
                    languages: lang,
                };

                await this.$http.post('/api/v1/admin/phrase_dictionary/special_symbols/', data);
                this.values = {
                    ...this.values,
                    symbol: '',
                    replace: '',
                    is_active: true,
                };

                this.$emit('saved', true);
            } catch (err) {
                console.log(err);
                this.error = err;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style src="./SpecialSymbols.scss" lang="scss"></style>
